import { useLanguage } from "@/components/language-provider";
import { LegalLayout } from "@/components/legal-layout";

export default function Terms() {
  const { language } = useLanguage();

  if (language === "en") {
    return (
      <LegalLayout title="Terms of Service">
        <p className="text-muted-foreground text-sm mb-8">Last updated: January 2026</p>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using FillSign ("Service"), you accept and agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>
        <h2>2. Description of Service</h2>
        <p>FillSign is a digital signature platform that allows users to create, send, sign, and manage electronic documents with legal validity in accordance with Brazilian legislation (MP 2.200-2/2001 and Law 14.063/2020).</p>
        <h2>3. User Accounts</h2>
        <p>You are responsible for maintaining the security of your account credentials. You must notify us immediately of any unauthorized use.</p>
        <h2>4. Acceptable Use</h2>
        <p>You agree not to use the Service for illegal purposes, to transmit malicious content, or to violate the rights of others.</p>
        <h2>5. Data Processing</h2>
        <p>Documents uploaded to FillSign are processed in accordance with our Privacy Policy. We use encryption at rest and in transit to protect your data.</p>
        <h2>6. Limitation of Liability</h2>
        <p>FillSign shall not be liable for any indirect, incidental, or consequential damages arising from the use of the Service.</p>
        <h2>7. Changes to Terms</h2>
        <p>We reserve the right to modify these terms at any time. Users will be notified of significant changes via email.</p>
        <h2>8. Contact</h2>
        <p>For questions about these Terms, contact us at legal@fillsign.com.</p>
      </LegalLayout>
    );
  }

  return (
    <LegalLayout title="Termos de Serviço">
      <p className="text-muted-foreground text-sm mb-8">Última atualização: Janeiro de 2026</p>
      <h2>1. Aceitação dos Termos</h2>
      <p>Ao acessar e usar o FillSign ("Serviço"), você aceita e concorda em estar vinculado a estes Termos de Serviço. Se não concordar, não utilize o Serviço.</p>
      <h2>2. Descrição do Serviço</h2>
      <p>O FillSign é uma plataforma de assinatura digital que permite criar, enviar, assinar e gerenciar documentos eletrônicos com validade jurídica conforme a legislação brasileira (MP 2.200-2/2001 e Lei 14.063/2020).</p>
      <h2>3. Contas de Usuário</h2>
      <p>Você é responsável por manter a segurança de suas credenciais de acesso. Qualquer uso não autorizado deve ser reportado imediatamente.</p>
      <h2>4. Uso Aceitável</h2>
      <p>Você concorda em não usar o Serviço para fins ilegais, transmitir conteúdo malicioso ou violar os direitos de terceiros.</p>
      <h2>5. Processamento de Dados</h2>
      <p>Documentos enviados ao FillSign são processados conforme nossa Política de Privacidade. Utilizamos criptografia em repouso e em trânsito para proteger seus dados.</p>
      <h2>6. Limitação de Responsabilidade</h2>
      <p>O FillSign não será responsável por danos indiretos, incidentais ou consequentes decorrentes do uso do Serviço.</p>
      <h2>7. Alterações nos Termos</h2>
      <p>Reservamo-nos o direito de modificar estes termos a qualquer momento. Usuários serão notificados de alterações significativas por email.</p>
      <h2>8. Contato</h2>
      <p>Para dúvidas sobre estes Termos, entre em contato pelo email legal@fillsign.com.</p>
    </LegalLayout>
  );
}
